<script setup lang="ts">
import type { SectionBaseItem } from '~/models/Content/SectionBaseItem'
import type { HomeVgs } from '~/models/Content/HomeVgs'
import { computed } from 'vue'
import { ContentType } from '~/models/Content/ContentType'
import { ColorName } from '~/models/Content/Color'
import useSections from '~/composables/useSections'
import useHome from '~/composables/useHome'
import { useAppColor } from '~/composables/useAppColor'
import SectionsSkeleton from '~/components/skeletons/SectionsSkeleton.vue'
import SectionRenderer from '~/components/ResourceEngine/SectionRenderer.vue'
import HomeVgsProducts from '~/components/home/homeVgs/HomeVgsProducts.vue'

useAppColor(ColorName.White)

const { data, isLoading } = useHome<HomeVgs>(ContentType.HomeVgs)

const sectionIds = computed(() => data?.value?.sections?.destinationContentIds ?? [])

const { data: sections, isLoading: isLoadingSections } = useSections<SectionBaseItem>(sectionIds, [
  ContentType.SectionStandalone,
  ContentType.SectionBox,
  ContentType.SectionExpanded,
])
</script>

<template>
  <HomeVgsProducts />

  <section
    v-if="isLoading || isLoadingSections"
    class="max-w-screen-au mx-auto"
  >
    <SectionsSkeleton />
  </section>

  <SectionRenderer
    v-else
    :items="sections ?? []"
  />
</template>
